<style scoped>
.v-application .text-h4 {
  font-family: "Prompt", sans-serif !important;
  font-size: 24px !important;
}
.text-spacing {
  letter-spacing: 0px !important;
}
.v-application .white {
  border: #ccd0d9 solid 1px !important;
}
</style>

<template>
  <div>
    <v-layout class="d-flex justify-space-between">
      <div
        class="text-h4 font-weight-black primary--text text-spacing"
        color="blue"
      >
        ค้นหา ตช.
      </div>
      <v-spacer></v-spacer>
      <v-btn
        class="mr-2"
        color="success"
        elevation="0"
        dark
        @click="addWaste()"
      >
        <v-icon left>mdi-magnify</v-icon>เพิ่ม ตช.
      </v-btn>
    </v-layout>
    <v-divider class="my-2"></v-divider>
    <div class="d-flex justify-space-around">
      <div class="mt-5" style="width: 40px">วันที่</div>
      <div>
        <date-picker
          color="black"
          class="mt-3"
          :format="momentFormat"
          style="width: 100%"
          v-model="search_dates"
          range
        ></date-picker>
      </div>
      <div>
        <v-select
          style="width: 100px"
          :items="carItem"
          label="รถทุกคัน"
          v-model="search_car"
          item-text="CAR_NUMBER"
          :item-value="carItem"
          return-object
        ></v-select>
      </div>
      <div>
        <v-combobox
          style="max-width: 250px; width: 100%"
          v-model="search_name"
          label="ชื่อสถานบริการ"
          :items="search_wastName"
          item-text="CUSTOMER_NAME"
          item-value="CUSTOMER_NAME"
          return-object
        ></v-combobox>
      </div>
      <div>
        <v-text-field
          v-model="search_wastID"
          label="เลขที่เอกสาร ตช."
        ></v-text-field>
      </div>
      <div>
        <v-btn
          class="mr-2 mt-5"
          color="error"
          elevation="0"
          dark
          @click="clear_search()"
        >
          <v-icon left>mdi-magnify</v-icon>ล้าง
        </v-btn>
        <v-btn
          class="mt-5"
          color="success"
          elevation="0"
          dark
          @click="searh_Car()"
        >
          <v-icon left>mdi-magnify</v-icon>ค้นหา
        </v-btn>
      </div>
    </div>
    <v-data-table
      :headers="headers"
      :items="wast_DocumentList"
      :search="search.CUSTOMER_NAME"
      sort-by="calories"
      class="elevation-1 enlarge-font"
      v-model="val_data_table"
    >
      <template v-slot:item.print="{ item }">
        <v-btn color="success" small class="mb-0" @click="print_contract(item)">
          <v-icon>mdi-printer</v-icon>
        </v-btn>
      </template>
      <template v-slot:item.edit="{ item }">
        <v-btn
          color="info"
          small
          class="mb-0 font-weight-bold"
          @click="view_document(item)"
        >
          <v-icon left>mdi-file-document-outline</v-icon>แสดง
        </v-btn>
      </template>
      <template v-slot:item.Time="{ item }"> {{ timeTH(item.W_I) }} </template>
      <template v-slot:[`item.actions`]="{ item }">
        <TableMenuCustomer
          :TableData="item"
          :whichPage="'waste_Doc'"
          ref="wasteDoc"
          v-on:myEvent="print_documents"
        ></TableMenuCustomer>
      </template>
      <template v-slot:item.CONTRACT_START_DATE="{ item }">{{
        contract_expier(item.CONTRACT_START_DATE, item.CONTRACT_END_DATE)
      }}</template>
      <template v-slot:item.CONTRACT_END_DATE="{ item }">{{
        item.CONTRACT_END_DATE | thdate
      }}</template>
      <template v-slot:no-data>
        <v-btn color="info" @click="initialize">
          <v-icon left>mdi-refresh</v-icon>รีเฟรชข้อมูล
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import pdfMake from "@/assets/build/pdfmake";
import pdfFonts from "@/assets/build/vfs_fonts";
import waste_document from "./pdf/WasteDocument";
import print_document from "./pdf/printWastDoc";
import print_document_a5 from "./pdf/printWastDocA5";
import moment from "moment";
import QrcodeVue from "qrcode.vue";
import TableMenuCustomer from "../components/TableMenuCustomer";

export default {
  components: {
    TableMenuCustomer,
    QrcodeVue,
  },
  data: () => ({
    fav: true,
    menu: false,
    message: false,
    hints: true,

    pagination: {
      sortBy: "name",
    },
    labels: "",
    momentFormat: {
      // Date to String
      stringify: (date) => {
        return date
          ? moment(date)
              .add(543, "year")
              .locale("th")
              .format("LL")
          : "";
      },
      // String to Date
      parse: (value) => {
        return value ? moment(value, "LL").toDate() : null;
      },
    },
    selected: [],
    search_dates: "",
    search_car: "",
    search_name: "",
    search_wastID: "",
    search_wastName: "",
    isMobile: false,
    search: "",
    wast_DocumentList: [],
    headers: [
      {
        text: "เลขที่เอกสาร ตช.",
        align: "start",
        sortable: true,
        value: "T_ID",
      },
      { text: "วันเก็บขน", value: "Time" },
      { text: "ลูกค้า", value: "C_N" },
      { text: "รถเก็บขน", value: "CAR_NUMBER" },
      { text: "น้ำหนัก กก.", value: "W_W" },
      // { text: "รายละเอียด", value: "edit", width: "10%" },
      // { text: "พิมพ์", value: "Time", width: "10%" },
      { text: "จัดการข้อมูล", value: "actions" },
    ],

    carItem: [],
    valueqr: "https://example.com",
    sizeqr: 100,
    val_data_table: [],
  }),
  beforeCreate() {},
  created() {
    this.lsit_car();
    this.list_wastDocument("");
    this.list_wastName();
  },
  methods: {
    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    },
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.desserts.slice();
    },
    changeSort(column) {
      //console.log(column);
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    view_document(item) {
      this.waste_documentpdf(item);
    },
    print_documents(item) {
      // this.search_search();
      this.print_documentpdf_a5(item);
    },

    async waste_documentpdf(item) {
      pdfMake.vfs = pdfFonts.pdfMake.vfs;
      pdfMake.fonts = {
        THSarabunNew: {
          normal: "THSarabunNew.ttf",
          bold: "THSarabunNew Bold.ttf",
          italics: "THSarabunNew Italic.ttf",
          bolditalics: "THSarabunNew BoldItalic.ttf",
        },
        Roboto: {
          normal: "Roboto-Regular.ttf",
          bold: "Roboto-Medium.ttf",
          italics: "Roboto-Italic.ttf",
          bolditalics: "Roboto-MediumItalic.ttf",
        },
      };

      pdfMake.createPdf(await waste_document(item)).open();
    },
    async print_documentpdf(item) {
      pdfMake.vfs = pdfFonts.pdfMake.vfs;
      pdfMake.fonts = {
        THSarabunNew: {
          normal: "THSarabunNew.ttf",
          bold: "THSarabunNew Bold.ttf",
          italics: "THSarabunNew Italic.ttf",
          bolditalics: "THSarabunNew BoldItalic.ttf",
        },
        Roboto: {
          normal: "Roboto-Regular.ttf",
          bold: "Roboto-Medium.ttf",
          italics: "Roboto-Italic.ttf",
          bolditalics: "Roboto-MediumItalic.ttf",
        },
      };

      pdfMake.createPdf(await print_document(item)).open();
    },
    async print_documentpdf_a5(item) {
      pdfMake.vfs = pdfFonts.pdfMake.vfs;
      pdfMake.fonts = {
        THSarabunNew: {
          normal: "THSarabunNew.ttf",
          bold: "THSarabunNew Bold.ttf",
          italics: "THSarabunNew Italic.ttf",
          bolditalics: "THSarabunNew BoldItalic.ttf",
        },
        Roboto: {
          normal: "Roboto-Regular.ttf",
          bold: "Roboto-Medium.ttf",
          italics: "Roboto-Italic.ttf",
          bolditalics: "Roboto-MediumItalic.ttf",
        },
      };

      pdfMake.createPdf(await print_document_a5(item,this.$AppName)).open();
    },
    clear_search() {
      this.search_dates = "";
      this.search_car = "";
      this.search_wastID = "";
      this.search_name = "";
    },
    testCar() {},
    async searh_Car() {
      console.log(this.search_car);
      let s_d = " ";
      let s_d1 = " ";
      let s_d2 = " ";
      let s_c = " ";
      let s_w = " ";
      let s_n = "";
      let s_ct = "";
      let last_mas = " ";
      if (
        this.search_dates &&
        this.search_car &&
        this.search_wastID &&
        this.search_name
      ) {
        console.log("1 2 3 4");
        // console.log(moment(this.search_dates[0]).format("YYYY-MM-DD 00:00:00"));
        // console.log(moment(this.search_dates[1]).format("YYYY-MM-DD 23:59:59"));
        s_d1 = moment(this.search_dates[0]).format("YYYY-MM-DD 00:00:00");
        s_d2 = moment(this.search_dates[1]).format("YYYY-MM-DD 23:59:59");
        s_c = this.search_car.CAR_NUMBER;
        s_ct = this.search_car.CAR_TYPE;
        s_w = this.search_wastID;
        s_n = this.search_name.CUSTOMER_NAME;
        last_mas = {
          s_d1s: s_d1,
          s_d2s: s_d2,
          s_cs: s_c,
          s_ws: s_w,
          s_n: s_n,
          s_ct: s_ct,
        };
      } else if (
        !this.search_dates &&
        this.search_car &&
        this.search_wastID &&
        this.search_name
      ) {
        console.log(" 2 3 4");
        s_c = this.search_car.CAR_NUMBER;
        s_ct = this.search_car.CAR_TYPE;
        s_w = this.search_wastID;
        s_n = this.search_name.CUSTOMER_NAME;
        last_mas = { s_cs: s_c, s_ws: s_w, s_n: s_n };
      } else if (
        this.search_dates &&
        !this.search_car &&
        this.search_wastID &&
        this.search_name
      ) {
        console.log("1  3 4");
        s_d1 = moment(this.search_dates[0]).format("YYYY-MM-DD 00:00:00");
        s_d2 = moment(this.search_dates[1]).format("YYYY-MM-DD 23:59:59");

        s_w = this.search_wastID;
        s_n = this.search_name.CUSTOMER_NAME;
        last_mas = { s_d1s: s_d1, s_d2s: s_d2, s_ws: s_w, s_n: s_n };
      } else if (
        this.search_dates &&
        this.search_car &&
        !this.search_wastID &&
        this.search_name
      ) {
        console.log("1 2 4");

        s_d1 = moment(this.search_dates[0]).format("YYYY-MM-DD 00:00:00");
        s_d2 = moment(this.search_dates[1]).format("YYYY-MM-DD 23:59:59");
        s_c = this.search_car.CAR_NUMBER;
        s_ct = this.search_car.CAR_TYPE;
        s_n = this.search_name.CUSTOMER_NAME;
        last_mas = {
          s_d1s: s_d1,
          s_d2s: s_d2,
          s_cs: s_c,
          s_n: s_n,
          s_ct: s_ct,
        };
      } else if (
        this.search_dates &&
        this.search_car &&
        this.search_wastID &&
        !this.search_name
      ) {
        console.log("1 2 3");

        s_d1 = moment(this.search_dates[0]).format("YYYY-MM-DD 00:00:00");
        s_d2 = moment(this.search_dates[1]).format("YYYY-MM-DD 23:59:59");
        s_c = this.search_car.CAR_NUMBER;
        s_ct = this.search_car.CAR_TYPE;
        s_n = this.search_name.CUSTOMER_NAME;
        last_mas = {
          s_d1s: s_d1,
          s_d2s: s_d2,
          s_cs: s_c,
          s_n: s_n,
          s_ct: s_ct,
        };
      } else if (
        !this.search_dates &&
        !this.search_car &&
        this.search_wastID &&
        this.search_name
      ) {
        console.log("3 4");

        s_w = this.search_wastID;
        s_n = this.search_name.CUSTOMER_NAME;
        last_mas = { s_ws: s_w, s_n: s_n };
      } else if (
        !this.search_dates &&
        this.search_car &&
        !this.search_wastID &&
        this.search_name
      ) {
        console.log(" 2  4");

        s_c = this.search_car.CAR_NUMBER;
        s_ct = this.search_car.CAR_TYPE;
        s_n = this.search_name.CUSTOMER_NAME;
        last_mas = { s_cs: s_c, s_n: s_n, s_ct: s_ct };
      } else if (
        !this.search_dates &&
        this.search_car &&
        this.search_wastID &&
        !this.search_name
      ) {
        // console.log("not null 2");
        console.log(" 2 3 ");
        s_w = this.search_wastID;
        s_c = this.search_car.CAR_NUMBER;
        s_ct = this.search_car.CAR_TYPE;
        last_mas = { s_cs: s_c, s_ws: s_w, s_ct: s_ct };
      } else if (
        this.search_dates &&
        !this.search_car &&
        !this.search_wastID &&
        this.search_name
      ) {
        console.log("1 4");
        s_d1 = moment(this.search_dates[0]).format("YYYY-MM-DD 00:00:00");
        s_d2 = moment(this.search_dates[1]).format("YYYY-MM-DD 23:59:59");
        s_n = this.search_name.CUSTOMER_NAME;
        last_mas = { s_d1s: s_d1, s_d2s: s_d2, s_n: s_n };
      } else if (
        this.search_dates &&
        !this.search_car &&
        this.search_wastID &&
        !this.search_name
      ) {
        console.log("1 3 ");
        s_d1 = moment(this.search_dates[0]).format("YYYY-MM-DD 00:00:00");
        s_d2 = moment(this.search_dates[1]).format("YYYY-MM-DD 23:59:59");
        s_w = this.search_wastID;
        last_mas = { s_d1s: s_d1, s_d2s: s_d2, s_ws: s_w };
      } else if (
        this.search_dates &&
        this.search_car &&
        !this.search_wastID &&
        !this.search_name
      ) {
        console.log("1 2 ");
        s_d1 = moment(this.search_dates[0]).format("YYYY-MM-DD 00:00:00");
        s_d2 = moment(this.search_dates[1]).format("YYYY-MM-DD 23:59:59");
        s_c = this.search_car.CAR_NUMBER;
        s_ct = this.search_car.CAR_TYPE;
        last_mas = { s_d1s: s_d1, s_d2s: s_d2, s_cs: s_c, s_ct: s_ct };
      } else if (
        this.search_dates &&
        !this.search_car &&
        !this.search_wastID &&
        !this.search_name
      ) {
        console.log("1 ");
        s_d1 = moment(this.search_dates[0]).format("YYYY-MM-DD 00:00:00");
        s_d2 = moment(this.search_dates[1]).format("YYYY-MM-DD 23:59:59");
        last_mas = { s_d1s: s_d1, s_d2s: s_d2 };
      } else if (
        !this.search_dates &&
        this.search_car &&
        !this.search_wastID &&
        !this.search_name
      ) {
        console.log("2 ");
        s_c = this.search_car.CAR_NUMBER;
        s_ct = this.search_car.CAR_TYPE;
        last_mas = { s_cs: s_c, s_ct: s_ct };
      } else if (
        !this.search_dates &&
        !this.search_car &&
        this.search_wastID &&
        !this.search_name
      ) {
        console.log("3 ");

        s_w = this.search_wastID;

        last_mas = { s_ws: s_w };
      } else if (
        !this.search_dates &&
        !this.search_car &&
        !this.search_wastID &&
        this.search_name
      ) {
        console.log("4 ");

        s_n = this.search_name.CUSTOMER_NAME;
        last_mas = { s_n: s_n };
      } else {
        // console.log("null all ");
        last_mas = { nulls: "y" };
      }
      console.log(last_mas);
      await this.list_wastDocument(last_mas);
    },
    lsit_car() {
      this.$token_api
        .get("/search_car")
        .then((res) => {
          // console.log(res.data.data);
          this.carItem = res.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async list_wastDocument(item) {
      this.$token_api
        .post("/search_wastDocument", item)
        .then((res) => {
          console.log(res.data.data);
          this.wast_DocumentList = res.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    list_wastName() {
      this.$token_api
        .get("/search_wastDocumentName")
        .then((res) => {
          //console.log(res.data.data);
          this.search_wastName = res.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    initialize() {
      this.list_wastDocument("");
    },
    timeTH(date) {
      return date
        ? moment(date)
            .add(543, "year")
            .locale("th")
            .format("LL")
        : "";
    },
    addWaste() {
      this.$store.dispatch("Waste/reset");
      this.$router.push({ path: "/wastedocument/add-waste-document" });
    },
  },
};
</script>
